export const TABLE_FILTERS = 'tableFilters';
export const TABLE_PAGER_LIMIT = 'tablePagerLimit';
export const TABLE_COLUMN_SIZING = 'tableColumnSizing';
export const SESSION_ID_KEY = 'sessionIdStorageKey';
export const SUMSUB_COUNTER = 'sumSubCounter';
